import {
  SearchSuggestionType,
  LinkTrackingData,
} from '../../../../../../AnalyticsContext/LinkTracking';
import { Atom } from '../../../../../icons/outlined/Atom';
import { HealthCross } from '../../../../../icons/outlined/HealthCross';
import { FilterChoice } from '../../../../types/FilterChoice';
import { renderLocationChoice } from '../../../../types/LocationChoice';
import { DEFAULT_SPECIALTY_ICONS } from '../../SuggestionLabel';
import {
  SuggestionIcon,
  SuggestionPrimary,
  SuggestionPrimaryLight,
  SpecialtyIcon,
} from '../SuggestionStyles/SuggestionStyles.styles';
import { SuggestionTemplate } from '../SuggestionTemplate/SuggestionTemplate';

interface Props {
  filters: FilterChoice;
  trackingData: LinkTrackingData;
}

export const FilterSuggestion = ({ filters: { location, topic }, trackingData }: Props) => {
  const { treatment, specialist } = topic || {};
  const icon = specialist ? DEFAULT_SPECIALTY_ICONS[specialist.toLowerCase()] : null;
  const specialtyIcon = icon ? <SpecialtyIcon src={icon} /> : <HealthCross />;
  return (
    <SuggestionTemplate
      trackingData={{
        ...trackingData,
        searchSuggestionType: treatment
          ? SearchSuggestionType.TOPIC
          : SearchSuggestionType.SPECIALTY,
      }}
      visual={<SuggestionIcon>{specialist ? specialtyIcon : <Atom />}</SuggestionIcon>}
      primary={
        <>
          {location && (
            <>
              <SuggestionPrimary>{treatment ?? specialist}</SuggestionPrimary>{' '}
              <SuggestionPrimaryLight>in</SuggestionPrimaryLight>{' '}
              <SuggestionPrimary>{renderLocationChoice(location)}</SuggestionPrimary>
            </>
          )}
          {!location && (
            <>
              <SuggestionPrimary>{treatment ?? specialist}</SuggestionPrimary>{' '}
            </>
          )}
        </>
      }
      showSpecialtyIcon={!!icon}
    />
  );
};
